import script from "./BotanicalIcon.vue?vue&type=script&lang=js"
export * from "./BotanicalIcon.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__